export { HeaderPompompurin } from './HeaderPompompurin';
export { BodyPompompurin } from './BodyPompompurin';
export { FooterPompompurin } from './FooterPompompurin';
